import { useRef } from 'react';

import { BpkButtonLink } from '@skyscanner/backpack-web/bpk-component-link';
import BpkText from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import useHandleViewMore from './useHandleViewMore';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './FlexibleText.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';

type Props = {
  content: string;
  limit?: number;
  i18n: I18nService;
  className?: string;
};

const cls = cssModules(STYLES);

const FlexibleText = ({ className, content, i18n, limit }: Props) => {
  const contentRef = useRef(null);
  const { toggleHeight, viewMore } = useHandleViewMore(contentRef);

  return (
    <div
      ref={contentRef}
      className={cls('FlexibleText', className)}
      // @ts-expect-error '--max-lines' does not exist in type Props'
      style={limit ? { '--max-lines': limit } : undefined}
    >
      <span
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML={{
          __html: content,
        }}
      />
      {viewMore && (
        <BpkButtonLink
          onClick={toggleHeight}
          className={cls('FlexibleText__btn')}
        >
          <BpkText>{i18n.translate('Button_viewMore')}</BpkText>
        </BpkButtonLink>
      )}
    </div>
  );
};

export default withI18n(FlexibleText);
